export default "If assets have a massive demand, you are incentivised to set the monopoly price (highest price anyone will pay).\n";